module.exports = __webpack_public_path__ + "static/img/finish.f6e08b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/finish.png
// module id = 472
// module chunks = 1